import { render } from "./DocumentsModeles.vue?vue&type=template&id=421019ac"
import script from "./DocumentsModeles.vue?vue&type=script&lang=js"
export * from "./DocumentsModeles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__